import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { navigate } from 'gatsby';
import { Paper } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import AddIcon from '@material-ui/icons/Add';
import { Fab, Tooltip } from '@material-ui/core';
import SearchOverview from 'components/SearchOverview';
import DetailsOverview from 'components/DetailsOverview';
import CopyPopover from 'components/CopyPopover';
import AttributeUpdater from 'components/AttributeUpdater';
import ObjectCreateDialog from 'components/ObjectCreateDialog';
import styles from './styles';


function ItemsContent({ classes, applications, accountId, authData, applicationObjects, presetFilter }) {
	const [selectedObject, setSelectedObject] = useState(null);
	const [updateAttribute, setUpdateAttribute] = useState(null);
	const [copyPopoverData, setCopyPopoverData] = useState(null);
	const [openCreateObjectDialog, setOpenCreateObjectDialog] = useState(false);

	const selectObject = (applicationObject) => () => {
		setSelectedObject(applicationObject);
		// Set hook, when a field of an application is selected
		applicationObject.setOnSelect((updateAttribute) => {
			setUpdateAttribute(updateAttribute);
		});
	}

	// Set hook when applicationObjects change
	applicationObjects.setOnChange(() => {
		if (selectedObject) {
			const updatedObject = applicationObjects.getObjectById(selectedObject.id);
			setUpdateAttribute(updatedObject.updateAttribute);
			if (selectedObject) {
				selectObject(updatedObject)(null);
			}
		}
	});

	const unselectObject = () => {
		setSelectedObject(null);
	}

	const copyData = () => {
		let data = document.getElementById('copyData').innerHTML;
		navigator.clipboard.writeText(data);
		setCopyPopoverData(null);
	}

	const selectCopyData = (path) => (applicationObject) => (event) => {
		const field = applicationObject.getFieldByPath(path);
		setCopyPopoverData({anchor: event.currentTarget, data: field.value, 
							onClick: copyData})
	}

	const toCodes = (applicationObject) => (event) => {
		navigate(`/codes?filter=${applicationObject.id}`);
	}

	const createObject = (event) => {
		setOpenCreateObjectDialog(true);
	} 

	// Filters item list
	const compare_string = (value, filter_str) => {
		return value.toLowerCase().startsWith(filter_str.toLowerCase())
	}

	const filter = (applicationObject, filter_str) => {
		if (!applicationObject || !filter_str) { return true; }

		if (applicationObject.id && compare_string(applicationObject.id, filter_str)) {
			return true;
		}
		
		for (const attribute of applicationObject.attributes) {
			if (attribute.value) {
				if ((typeof attribute.value == 'string') && compare_string(attribute.value, filter_str)) {
					return true;
				} else if (Array.isArray(attribute.value)) {
					for (const sub_val of attribute.value) {
						if (compare_string(sub_val, filter_str)) {
							return true;
						}
					}
				}
			}
		}
		return false;
	}

	return (
		<div className={classes.container}>
			<Paper className={classes.paper}>
				{(!selectedObject) ? (
					<>
					<SearchOverview
						applicationObjects={applicationObjects}
						objectsActions={applicationObjects.getActions(selectCopyData, toCodes, selectObject)}
						filter={filter}
						presetFilter={presetFilter}
					/>
					<Tooltip title={`Create new ${applicationObjects.objectName}`} 
							 aria-label="add"
							 open={!(applications && applications.ready)}
							 className={classes.fab} >
						<span>
							<Fab 
								color="primary"
								disabled={!(applications && applications.ready)}
								onClick={createObject}>
								<AddIcon />
							</Fab>
						</span>
					</Tooltip>
					</>
				) : (
					<DetailsOverview 
						applicationObjects={applicationObjects}
						applicationObject={selectedObject}
						actions={[]}
						onCloseDetails={unselectObject} 
					/>
				)}
				{(updateAttribute) ? (
					<AttributeUpdater
						applications={applications}
						applicationObjects={applicationObjects}
						applicationObject={selectedObject}
						updateAttribute={updateAttribute}
						authData={authData}
					/>
				) : null }
				{(openCreateObjectDialog) ? (
					<ObjectCreateDialog
						applications={applications}
						applicationObjects={applicationObjects}
						onClose={() => setOpenCreateObjectDialog(false)}
						selectObject={selectObject}
						accountId={accountId}
						authData={authData}
					/>
				) : null }
			</Paper>
			<CopyPopover
				data={copyPopoverData}
				setData={setCopyPopoverData} 
			/>
		</div>
	);
}

ItemsContent.propTypes = {
	classes: PropTypes.object.isRequired,
	applications: PropTypes.object,
	accountId: PropTypes.string.isRequired,
	authData: PropTypes.object.isRequired, 
	applicationObjects: PropTypes.object.isRequired,
	presetFilter: PropTypes.string
}
export default withStyles(styles)(ItemsContent)
